import { useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import { clearParams } from '~/shared';
import {
  ReportsSponsoredProductModelView,
  SponsoredProductsReportsBannerDto,
} from '~/types';

export const GET_SPONSORED_PRODUCTS_REPORTS_PRODUCT_QUERY_KEY =
  'GET_SPONSORED_PRODUCTS_REPORTS_PRODUCT_QUERY';

function getSponsoredProductsReportsProduct(
  params: SponsoredProductsReportsBannerDto
) {
  const clearedParams = clearParams(
    params
  ) as SponsoredProductsReportsBannerDto;
  return serviceApi.get<ReportsSponsoredProductModelView>(
    '/ReportProdutoPatrocinado/DailyRegister',
    {
      params: clearedParams,
    }
  );
}

export function useGetSponsoredProductsReportsProduct(
  params: SponsoredProductsReportsBannerDto
) {
  return useQuery({
    queryKey: [GET_SPONSORED_PRODUCTS_REPORTS_PRODUCT_QUERY_KEY, params],
    queryFn: () => getSponsoredProductsReportsProduct(params),
    select: data => data.data,
  });
}
